import { render, staticRenderFns } from "./orderXpInfo.vue?vue&type=template&id=01e0c7d4&scoped=true"
import script from "./orderXpInfo.vue?vue&type=script&lang=js"
export * from "./orderXpInfo.vue?vue&type=script&lang=js"
import style0 from "./orderXpInfo.vue?vue&type=style&index=0&id=01e0c7d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e0c7d4",
  null
  
)

export default component.exports